import { Component, OnInit, input } from '@angular/core';
import { TextComponent } from '../../../atoms/text/text.component';

@Component({
  selector: 'app-radio-button-label',
  templateUrl: './radio-button-label.component.html',
  styleUrls: ['./radio-button-label.component.scss'],
  imports: [TextComponent],
})
export class RadioButtonLabelComponent implements OnInit {
  readonly text = input('');

  constructor() {}

  ngOnInit(): void {}
}
